module.exports = __webpack_public_path__ + "static/media/MSEDCL_logo.61eb120f.png";